//  环境变量
//  pro     正式环境，
//  local   本地运行，
//  sit     测试环境
let env = "pro";
const host = window.location.host;
if (host.includes("localhost")) {
  env = "local";
} else if (host.includes("hd-sit1.test")) {
  env = "sit";
} else if (host.includes("hd-uat1.test")) {
  env = "uat";
}

// 游戏墙扫码后获取跳转的游戏链接URL所对应的接口
export const getJumpLinkUrlInterface = function() {
  const hostname = window.location.hostname;
  if (hostname.includes("localhost")) {
    return "https://apigw-beta.test.hihonor.com/api/get-download-url/sit/";
  } else if (hostname.includes("hd-sit1.test")) {
    return "https://apigw-beta.test.hihonor.com/api/get-download-url/sit/";
  } else if (hostname.includes("hd-uat1.test")) {
    return "https://apigw-beta.test.hihonor.com/api/get-download-url/uat/";
  } else {
    return "https://apigw.yun.hihonor.com/api/get-download-url/cn/";
  }
};

// 游戏墙扫码后调这个下载s3附件接口，入参downloadUrl，获取图片的下载地址
export const getImageUrlData = function() {
  const hostname = window.location.hostname;
  if (hostname.includes("localhost")) {
    return "https://retail-sit.test.hihonor.com/hsso/hardware/live-demo/attachment/download";
  } else if (hostname.includes("hd-sit1.test")) {
    return "https://retail-sit.test.hihonor.com/hsso/hardware/live-demo/attachment/download";
  } else if (hostname.includes("hd-uat1.test")) {
    return "https://retail-uat.test.hihonor.com/hsso/hardware/live-demo/attachment/download";
  } else {
    return "https://retail.hihonor.com/hsso/hardware/live-demo/attachment/download";
  }
};

export const config = {
  env: env
};



// WEBPACK FOOTER //
// ./src/commons/config.js